import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ItemDescriptionComponent } from '@modules/common/components/item-description/item-description.component';
import { SharedBaseComponent } from '@modules/common/components/shared-base/shared-base.component';
import { StchHighlightTextDirective } from '@modules/common/directives/stch-highlight-text.directive';
import { DateFormatPipe } from '@modules/common/pipes/date-format.pipe';
import { IconComponent } from '@frontendlib/components/components/icon/icon.component';
import { SharedKnotsComponent } from '@modules/knots/components/shared-knots/shared-knots.component';
import { SharedSignupCtaComponent } from '@modules/common/components/shared-signup-cta/shared-signup-cta.component';
import { SharedTagsComponent } from '@modules/tags/components/shared-tags/shared-tags.component';
import { TaskingAppContextDirective } from '@modules/tasks/directives/app-tasking-app-context.directive';
import { Project } from '@modules/tasks/types/project';
import { StitchType } from '@sharedlib/common/types/StitchType';

@Component({
  selector: 'stch-project-shared',
  templateUrl: './project-shared.component.html',
  styleUrls: ['../../../common/components/shared-base/shared-base.component.less'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TaskingAppContextDirective,
    IconComponent,
    DateFormatPipe,
    ItemDescriptionComponent,
    SharedTagsComponent,
    SharedKnotsComponent,
    SharedSignupCtaComponent,
    StchHighlightTextDirective,
  ],
})
export class ProjectSharedComponent extends SharedBaseComponent<Project> {
  protected override stitchType = StitchType.PROJECT;

  protected get project(): Project {
    return this.stitchItem?.();
  }
}
